export default __webpack_public_path__ + "a525e6b7c2ba6c188ab0fa65441865a3.png";